exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".badge[data-v-8179917e]{cursor:default!important}.master-name[data-v-8179917e]{color:grey;font-size:70%;font-style:italic}.mw-270[data-v-8179917e]{max-width:270px}", ""]);

// exports
